import { authHeader } from "./data";
import authAxios from "./data";

const get = async () => {
  const response = await authAxios.get("/api/UserDataCheck", {
    headers: authHeader(),
  });

  return response.data;
};

const update = async (request: any) => {
  const response = await authAxios.post("/api/UserDataCheck", request, {
    headers: authHeader(),
  });

  return response.data;
};

const UserDataCheckService = {
  get,
  update,
};

export default UserDataCheckService;
